import { render, staticRenderFns } from "./offer-box.vue?vue&type=template&id=5876b034&scoped=true&"
import script from "./offer-box.vue?vue&type=script&lang=js&"
export * from "./offer-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876b034",
  null
  
)

export default component.exports